import React, { useMemo } from 'react';
import block from 'bem-cn';
import { shallowEqual } from 'react-redux';
import { formatNumber } from 'shared/utils/formatNumber';

import { useAppSelector } from 'shared/hooks';

import number1IMG from './img/number1.webp';
import number2IMG from './img/number2.webp';
import number3IMG from './img/number3.webp';

import './Item.scss';

const b = block('statistic-table-row-mobile');

const Item = ({ item, type }) => {
  const locale = useAppSelector(state => state.locale.locale, shallowEqual);

  const icon = useMemo(() => {
    if (item.number === 1) return number1IMG;
    if (item.number === 2) return number2IMG;
    if (item.number === 3) return number3IMG;
    return '';
  }, [item.number]);

  return (
    <div className={b({ wrapper: Boolean(item.number) && Boolean(icon) })}>
      <div className={b({ number: item.number })}>
        {icon && (
          <div className={b('td-icon-wrap')}>
            <img className={b('td-icon')} src={icon} alt="" />
          </div>
        )}

        <div className={b('tr1')}>
          <div className={b('td1')}>
            <span className={b('td1-value')}>№ {item.number}</span>
          </div>

          <div className={b('td2')}>
            <span className={b('td2-title')}>{locale.id}:</span>
            <span className={b('td2-value')}>{item.id}</span>
          </div>

          <div className={b('td3')}>
            <span className={b('td3-value')}>{item.username}</span>
          </div>
        </div>

        <div className={b('tr2')}>
            <div className={b('td4')}>
              <span className={b('td4-title')}>{locale.GGR}</span>
              <span className={b('td4-value')}>{formatNumber(item.ggr)}</span>
            </div>
          </div>
      </div>
    </div>
  );
};

export default Item;
